import React from "react";
import SignInModalContainer from "../containers/SignInModalContainer";
import { withTranslation } from "react-i18next";
// import SignUpContainer from "ui/my_account_button/containers/SignUpContainer";
// import EmailVerification from "ui/my_account_button/components/EmailVerification";
// import FirstSignIn from "ui/my_account_button/components/FirstSignIn";
// import SignIn from "ui/my_account_button/components/SignIn";
// import ForgotPassword from "ui/my_account_button/components/ForgotPassword";
// import EmailSent from "ui/my_account_button/components/EmailSent";
// import Modal from "ui/my_account_button/components/Modal";

const AnonymousMyAccountButton = ({ showSignInModal, loading, handleClick, t }) => (
    <>
        <a
            className="account-btn  inline-flex items-center rounded-full border border-transparent
          bg-orange-600 p-2 py-1 text-sm font-medium text-white hover:bg-[rgb(68,65,74)] transition-colors"
            href="#"
            title={t("account_button.connect")}
            onClick={handleClick}
        >
            {loading && (
                <i className="fa fa-fw fa-circle-notch fa-spin" aria-hidden="true" />
            )}
            {!loading && <i className="fa fa-fw fa-user hidden-xs" aria-hidden="true" />}
            <span>{t("account_button.log_in")}</span>
        </a>
        <SignInModalContainer open={showSignInModal} className="login-popin" />
        {/*<a className="account-btn" href="#" title={t('account_button.connect')} onClick={handleClick}>*/}
        {/*    {loading && <i className="fa fa-fw fa-circle-notch fa-spin" aria-hidden="true" />}*/}
        {/*    {!loading && <i className="fa fa-fw fa-user hidden-xs" aria-hidden="true" />}*/}
        {/*    <span>{t('account_button.my_account')}</span>*/}
        {/*</a>*/}
        {/*{showSignInModal && <SignInModalContainer className="login-popin" />}*/}
    </>
);
export default withTranslation()(AnonymousMyAccountButton);
